import i18n from "config/i18next";

i18n.addResources("es", "header", {
  admin: "ADMIN",
  reports: "Reportes",
  dashboard: "Monitor",
  pickers: "Flota",
  transactions: "Transacciones",
  administration: "Administración",
  governmentalEntity: "Ente gubernamental",
  loadFile: "Cargar",
  update: "Actualizar",
  preliquidations: "Preliquidaciones",
  config: "Configuraciones",
  polygons: "Polígonos",
  slots: "Turnos",
  termsAndConditions: "Términos y condiciones",
  logout: "Cerrar sesión",
});
